// extracted by mini-css-extract-plugin
export default {"coverLink":"HK-z","contentBox":"IK-z","zapposPromoContainer":"JK-z","zapposPromoGroupContainer":"KK-z","promos":"LK-z","bottom":"MK-z","top":"NK-z","right":"OK-z","left":"PK-z"};